import React, { useState } from 'react';
import { TextField, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { validateEmail } from '../../utils';

/**
 * 비밀번호 재설정 폼 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @param {string} props.resetPasswordEmail - 재설정 이메일
 * @param {function} props.setResetPasswordEmail - 재설정 이메일 설정 함수
 * @param {string} props.resetPasswordSuccess - 성공 메시지
 * @param {string} props.resetPasswordError - 에러 메시지
 * @param {function} props.handlePasswordReset - 비밀번호 재설정 함수
 * @param {string} props.emailError - 이메일 에러 메시지
 * @param {function} props.setEmailError - 이메일 에러 설정 함수
 * @returns {JSX.Element} - 비밀번호 재설정 폼
 */
const PasswordResetForm = ({
  resetPasswordEmail,
  setResetPasswordEmail,
  resetPasswordSuccess,
  resetPasswordError,
  handlePasswordReset,
  emailError,
  setEmailError
}) => {
  const { t } = useTranslation();

  /**
   * 비밀번호 재설정 폼 제출 핸들러
   * @param {Event} e - 폼 이벤트
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(resetPasswordEmail)) {
      setEmailError(t('auth.validEmailRequired'));
      return;
    }
    await handlePasswordReset(resetPasswordEmail);
  };

  return (
    <form onSubmit={handleSubmit}>
      {resetPasswordSuccess && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {t('auth.resetEmailSent')}
        </Alert>
      )}
      {resetPasswordError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {resetPasswordError}
        </Alert>
      )}
      <TextField
        fullWidth
        label={t('auth.email')}
        type="email"
        value={resetPasswordEmail}
        onChange={(e) => setResetPasswordEmail(e.target.value)}
        margin="normal"
        required
        error={!!emailError}
        helperText={emailError}
      />
      <Button
        fullWidth
        variant="contained"
        type="submit"
        sx={{ mt: 2 }}
      >
        {t('auth.resetPasswordEmail')}
      </Button>
    </form>
  );
};

export default PasswordResetForm; 